import Vue from 'vue';
import Component from 'vue-class-component';
// import { Watch } from 'vue-property-decorator';
import { eventBus } from '@/eventBus';
import { getViewSections } from '@/common/resourceNavigationUtil';

@Component({
  props: {},
})
export default class FaqClientTagMixin extends Vue {
  ready = true;
  showAllTags = false;
  tagListTop = 0;
  tagListBottom = 0;
  selectedCategories = [];
  initAutoScroll = true;

  // @Watch('navigationStore.state.routes')
  // onRouteChanged() {
  //   if (this.sections.scenario.length || this.sections.result.length) {
  //     this.$nextTick(() => {
  //       this.scrollTo(this.scrollFaqElement, {
  //         container: this.scrollContainer,
  //         x: false,
  //       });
  //     });
  //   }
  // }
  customListHeight() {
    return this.tagListBottom - this.tagListTop;
  }
  isChrome() {
    return (
      !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
    );
  }
  calcBarWidth(count) {
    return count >= 100 ? 150 : 150 * (count / 100);
  }
  selectItem(item) {
    const routes = [];
    for (let current = item; current; current = current.parent) {
      routes.unshift(current);
    }
    routes.push.apply(routes, {});
    this.$store.commit('navigation/setRoutes', routes);
    this.$store.commit('navigation/setIndex', routes.length - 1);
  }
  setSearchText(searchText) {
    this.$store.dispatch('tagSearch/setSearchText', searchText);
  }
  removeSelectedTag(tag) {
    this.$store.dispatch('tagSearch/removeSelectedTag', tag);
  }
  addSelectedTag(tag) {
    this.$store.dispatch('tagSearch/addSelectedTag', tag);
  }
  onShowAllTags(value) {
    this.showAllTags = value;
  }
  setTagListTop() {
    this.tagListTop =
      this.$refs.taggedInput.offsetTop + this.$refs.taggedInput.offsetHeight;
    this.tagListBottom = this.tagListTop + this.$refs.tagList.offsetHeight;
  }
  handleScenario(e) {
    if (
      this.$refs.scenario &&
      !this.$refs.scenario.contains(e.target) &&
      (this.$refs.listWrapper && !this.$refs.listWrapper.contains(e.target)) &&
      (this.$refs.modal && !this.$refs.modal.contains(e.target))
    ) {
      this.resetRoutes();
    }
  }
  handleTagList(e) {
    if (this.$refs.modal && this.$refs.modal.contains(e.target)) {
      this.setTagSearchShow(false);
    }
  }
  async resetInput() {
    await this.$store.dispatch('tagSearch/resetInput');
  }
  async updateTagsItems() {
    await this.$store.dispatch('tagSearch/updateTagsItems');
  }
  async setTagSearchShow(show) {
    setTimeout(() => {
      this.$store.commit('tagSearch/setShow', show);
    }, 0);
  }
  async tagfiyText(tagText) {
    await this.$store.dispatch('tagSearch/tagifyText', tagText);
  }
  async tagifyText(tagText) {
    console.log(tagText);
    await this.$store.dispatch('tagSearch/tagifyText', tagText);
  }
  resetRoutes() {
    const routes = [];
    for (
      let current = this.$store.state.navigation.routes[0];
      current;
      current = current.parent
    ) {
      routes.unshift(current);
    }
    routes.push.apply(routes, {});
    this.$store.commit('navigation/setRoutes', routes);
    this.$store.commit('navigation/setIndex', 0);
  }
  reset() {
    this.resetInput();
    this.updateTagsItems();
    this.setTagSearchShow(false);
    this.resetRoutes();
    this.setSelectedCategories([]);
  }
  resetWithScrollTop() {
    this.reset();
    if (!this.autoScrollElement || this.$store.state.user.isIphone) {
      setTimeout(() => {
        this.scrollToTop();
      }, 0);
    }
  }
  scrollTo(element, option) {
    this.$scrollTo(element, option);
  }
  scrollToTop() {
    const element = this.$store.state.user.isIphone
      ? this.iphoneTopElement
      : this.scrollTopElement;
    this.scrollTo(element, {
      container: this.scrollContainer,
      x: false,
    });
  }
  scrollToFaqTitle() {
    this.scrollTo(this.scrollFaqElement, {
      container: this.scrollContainer,
      x: false,
    });
  }
  scrollToSearch() {
    this.scrollTo(this.scrollSearchElement, {
      container: this.scrollContainer,
      x: false,
    });
  }
  autoScroll() {
    if (this.initAutoScroll) {
      this.setInitAutoScroll(false);
      return;
    }
    if (!this.$store.state.tagSearch.show) {
      this.scrollTo(this.autoScrollElement, {
        container: this.scrollContainer,
        x: false,
        duration: 1000,
      });
    }
  }
  setInitAutoScroll(boolean) {
    this.initAutoScroll = boolean;
  }
  setSelectedCategories(categories) {
    this.selectedCategories = categories;
  }
  resetTicket() {
    this.$ticket.reset();
    this.$store.dispatch('ticket/resetTicketState');
  }
  generateClearTicket() {
    const startTime =
      this.$store.state.ticket.startTime || String(new Date().getTime());
    this.$store.commit('ticket/setStartTime', startTime);

    const newTicket = {
      origin: 'window',
      user_agent: this.$store.state.user.userAgent,
      user_id: this.$store.state.user.Id,
      product_type: this.$store.state.productType,
      start_time: startTime,
      end_time: String(new Date().getTime()),
      status: 'open',
    };

    return newTicket;
  }
  updateTicket() {
    const startTime =
      this.$store.state.ticket.startTime || String(new Date().getTime());
    this.$store.commit('ticket/setStartTime', startTime);
    const keywordTags = this.$store.getters['tagSearch/selectedKeywordTags'];
    const tagActiveSet =
      keywordTags.length === 0
        ? []
        : keywordTags.map(t => {
            const v = { id: t.id, text: t.text };
            if (t.displayText) {
              v.label = t.displayText;
            }
            return v;
          });
    if (
      keywordTags.length > 0 &&
      this.$store.state.ticket.tagUsedSet.length === 0
    ) {
      this.$store.commit('ticket/setTagUsedSet', tagActiveSet);
    }
    const query = this.$store.state.tagSearch.searchText;
    if (query && this.$store.state.ticket.historyQuery.length === 0) {
      this.$store.commit('ticket/setHistoryQuery', [query]);
    }
    return this.generateTicket(startTime, query, tagActiveSet);
  }
  generateTicket(startTime, query, tagActiveSet) {
    const newTicket = {
      origin: 'window',
      user_agent: this.$store.state.user.userAgent,
      user_id: this.$store.state.user.Id,
      product_type: this.$store.state.productType,
      start_time: startTime,
      end_time: String(new Date().getTime()),
      query: query,
      tag_active_set: tagActiveSet,
      tag_used_set: this.$store.state.ticket.tagUsedSet,
      history_query: this.$store.state.ticket.historyQuery,
      history_action_faq_channel: this.$store.state.ticket
        .historyActionFaqChannel,
      status: 'open',
    };
    return newTicket;
  }

  get sections() {
    return getViewSections(this.$store.state.navigation.routes);
  }
  get searchText() {
    return this.$store.state.tagSearch.searchText;
  }
  get show() {
    return this.$store.state.tagSearch.show;
  }
  get allTags() {
    return this.$store.state.tagSearch.candidateTags;
  }
  get selectedTags() {
    return this.$store.state.tagSearch.selectedTags;
  }
  get candidateTags() {
    return this.$store.state.tagSearch.candidateTags;
  }
  get categorizedCandidateTags() {
    const tags = this.$store.state.tagSearch.candidateTags
      .filter(item => item.kana)
      .sort((a, b) => {
        return a.kana.localeCompare(b.kana);
      });
    const categorizedCandidateTags = [];
    let categoryName = null;
    for (const tag of tags) {
      const text = tag.kana;
      const currentCategoryName = text[0];
      if (categoryName !== currentCategoryName) {
        categorizedCandidateTags.push({
          title: currentCategoryName,
          tags: [],
        });
        categoryName = currentCategoryName;
      }
      categorizedCandidateTags[categorizedCandidateTags.length - 1].tags.push(
        tag
      );
    }
    return categorizedCandidateTags;
  }
  get filteredItems() {
    return this.$store.state.tagSearch.filteredItems;
  }
  get topTags() {
    return this.$store.state.tagSearch.topTags;
  }
  get loading() {
    return this.topTagsLoading && this.filteredItemsLoading && this.inputEmpty;
  }
  get topTagsLoading() {
    return Object.keys(this.$store.state.tagSearch.topTags).length === 0;
  }
  get filteredItemsLoading() {
    return this.$store.state.tagSearch.filteredItems.length === 0;
  }
  get inputTagEmpty() {
    return this.selectedTags.values().length === 0;
  }
  get inputEmpty() {
    return this.selectedTags.values().length === 0 && !this.searchText;
  }
  get isAutocompleteShown() {
    return this.$store.state.tagSearch.show;
  }
  get onIME() {
    return this.$store.state.onIME;
  }
  get showResult() {
    return this.sections.scenario.length > 0 || this.sections.result.length > 0;
  }
  get initialRecommendFaq() {
    return this.filteredItems.length > 0 && this.inputEmpty;
  }
  get noRecommendFaq() {
    return this.filteredItems.length === 0 && !this.inputEmpty;
  }
  get currentFaq() {
    return this.$store.state.navigation.routes[this.sections.talkScript.end];
  }
  get scriptAncesters() {
    return this.$store.state.navigation.routes[this.sections.talkScript.end]
      .ancesters;
  }
  created() {
    eventBus.$on('reset', () => {
      this.reset();
    });
    eventBus.$on('resetRoutes', () => {
      this.resetRoutes();
    });
    eventBus.$on('resetInput', () => {
      this.resetInput();
    });
    eventBus.$on('resetWithScrollTop', () => {
      this.resetWithScrollTop();
    });
    eventBus.$on('scrollToTop', () => {
      this.scrollToTop();
    });
    eventBus.$on('scrollToFaqTitle', () => {
      this.scrollToFaqTitle();
    });
    eventBus.$on('scrollToSearch', () => {
      this.scrollToSearch();
    });
    eventBus.$on('toggleIme', boolean => {
      this.$store.commit('setIME', boolean);
    });
    eventBus.$on('setSelectedCategories', categories => {
      this.setSelectedCategories(categories);
    });
    eventBus.$on('setTagSearchShow', boolean => {
      this.setTagSearchShow(boolean);
    });
    eventBus.$on('addSelectedTag', tag => {
      this.addSelectedTag(tag);
    });
    eventBus.$on('selectItem', item => {
      this.selectItem(item);
    });
    eventBus.$on('resetTicket', () => {
      this.resetTicket();
    });
  }
  updated() {
    this.setTagListTop();
  }
  mounted() {
    this.$refs.faqClientTag.addEventListener('click', e => {
      this.handleTagList(e);
    });
    this.setTagListTop();
    window.addEventListener('resize', () => {
      this.setTagListTop();
    });
  }
  beforeDestroy() {
    this.$refs.faqClientTag.removeEventListener(
      'click',
      e => {
        this.handleTagList(e);
      },
      false
    );
    window.removeEventListener('resize', this.setTagListTop);
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FaqClientTagMixin.js